import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
// import { ReactComponent as ChannelTalk } from '../../../assets/channelTalk.svg';

interface Props {
  title: string;
  isOpen?: boolean;
  maxWidth?: Breakpoint;
  onClose: () => void;
}

function Confirm(props: Props) {
  const { title, isOpen = false, maxWidth = 'xs', onClose } = props;
  const navigate = useNavigate();

  return (
    <Dialog maxWidth={maxWidth} open={isOpen} onClose={onClose}>
      <DialogTitle>
        <DialogActions>
          <Button
            variant="text"
            onClick={onClose}
            sx={{
              marginRight: '-20px',
              color: 'black',
              backgroundColor: 'white',
            }}
          >
            <CloseIcon />
          </Button>
        </DialogActions>
        <Typography sx={{ fontSize: '24px', fontWeight: 700 }}>
          忘记电子邮件?
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          whiteSpace: 'pre-line',
          wordBreak: 'keep-all',
          lineHeight: '24px',
        }}
      >
        <Typography sx={{ fontSize: '16px', fontWeight: '700' }}>
          1. 如果您只在网站上注册 :
        </Typography>
        ENR 的會員註冊需另外辦理， 與網站會員註冊為不同系統，請特別留意！
        <div style={{ marginTop: '15px', marginBottom: '20px' }}>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            sx={{
              cursor: 'pointer',
              backgroundColor: 'white',
              color: '#2D73DC',
              border: '1px solid #2D73DC',
              ':hover': {
                color: `#2D73DC`,
                backgroundColor: '#e6e7e9',
                border: `1px solid #82a6dc`,
              },
            }}
            onClick={() => navigate('/signup')}
          >
            SmartENR 注册
          </Button>
        </div>
        <Typography sx={{ fontSize: '16px', fontWeight: '700' }}>
          2. 如果您已注册ENR但忘记了您的电子邮件 :
        </Typography>
        请点击下面的“联系我们”按钮，并填写您的学校、学号和姓名。
        <div style={{ marginTop: '1rem', marginBottom: '30px' }}>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            sx={{
              cursor: 'pointer',
              backgroundColor: 'white',
              color: '#2D73DC',
              border: '1px solid #2D73DC',
              ':hover': {
                color: `#2D73DC`,
                backgroundColor: '#e6e7e9',
                border: `1px solid #82a6dc`,
              },
            }}
            onClick={() => window.open('https://vd48q.channel.io/')}
          >
            联系我们
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default Confirm;
